import { SystemEvent } from '@mbrtargeting/metatag-shared-types/metatag-core';
import { addCssToElement, isString } from '@mbrtargeting/metatag-utils';
import { inject, injectionTarget } from '../../../loader/decorators/inject.js';
import { onSystemEvent } from '../../../loader/decorators/on-system-event.js';
import { ConfigResolver } from '../../../loader/essentials/config-resolver.js';
import { selectCommonSettings } from '../../../loader/essentials/config-selector.js';
import { CONFIG_RESOLVER } from '../../../loader/token.js';

@injectionTarget()
export class CssInjector {

    @inject(CONFIG_RESOLVER) private configResolver!: ConfigResolver;

    @onSystemEvent(SystemEvent.SDG_CONFIG_FILE_AVAILABLE)
    init(): void {
        const { css = '' } = this.configResolver.get(selectCommonSettings());
        const cssText = isString(css) ? css : Object.values(css).join('\n');
        addCssToElement(cssText, document.head);
    }
}
